import { tWithKeyAttr as t } from "../../i18nHelper";
import chatSidebarStyles from "./chatSidebar.module.css";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import avatarPlaceholder from "../../images/avatar_placeholder.svg";
import { useAppSelector } from "../../services/hooks";
import { chatUsersSelector } from "../../services/selectors/chat.selector";
import { IConversation } from "../../types/types";

interface ChatSideBarProps {
  therapist: undefined | IConversation;
  setTherapist: Dispatch<SetStateAction<undefined | IConversation>>;
  setOpenSideBar?: Dispatch<SetStateAction<boolean>>;
  openMenu: boolean;
}

const ChatSideBar: React.FC<ChatSideBarProps> = ({
  therapist,
  setTherapist,
  openMenu,
  setOpenSideBar,
}) => {
  const chatUsers = useAppSelector(chatUsersSelector);

  const [users, setUsers] = useState(chatUsers);
  const [showActiveAppointments, setShowActiveAppointments] = useState(true);

  useEffect(() => {
    if (showActiveAppointments) {
      const activeUsers = chatUsers.filter(
        (u) => u.appointment && u.appointment?.appointments?.active
      );
      setUsers(activeUsers);
      // activeUsers[0] && setActiveUser(activeUsers[0]);
    } else {
      setUsers(chatUsers);
    }
  }, [showActiveAppointments, chatUsers, setTherapist]);

  return (
    <section
      className={`${chatSidebarStyles.sidebar} ${
        !openMenu && chatSidebarStyles.sidebar_closed
      }`}
    >
      <div className={chatSidebarStyles.sidebar__buttons}>
        <button
          className={`${chatSidebarStyles.sidebar__btn} ${
            !showActiveAppointments && chatSidebarStyles.sidebar__btn_active
          }`}
          onClick={() => {
            setShowActiveAppointments(false);
            setTherapist(undefined);
          }}
          data-testid="archive-button"
        >
          {t('ARCHIVE')}</button>
        <button
          className={`${chatSidebarStyles.sidebar__btn} ${
            showActiveAppointments && chatSidebarStyles.sidebar__btn_active
          }`}
          onClick={() => {
            setShowActiveAppointments(true);
            setTherapist(undefined);
          }}
          data-testid="chats-button"
        >
          {t('CONVERSATIONS')}</button>
      </div>
      {/*<input*/}
      {/*  type="text"*/}
      {/*  placeholder="חיפוש"*/}
      {/*  className={chatSidebarStyles.sidebar__input}*/}
      {/*/>*/}
      {users.length > 0 ? (
        <ul
          className={`${chatSidebarStyles.sidebar__therapists} ${chatSidebarStyles.scrollable} scroll`}
        >
          {users.map((u) => (
            <li
              key={u.userId}
              className={`${chatSidebarStyles.sidebar__li} ${
                u.userId === therapist?.userId &&
                chatSidebarStyles.sidebar__li_active
              }`}
              onClick={() => {
                setTherapist(u);
                if (setOpenSideBar) setOpenSideBar(false);
              }}
            >
              <div
                className={`${chatSidebarStyles.sidebar__online} ${
                  u.online && chatSidebarStyles.sidebar__online_active
                }`}
                data-testid="status-indicator"
              >
                <img
                  className={chatSidebarStyles.sidebar__avatar}
                  src={u?.avatar || avatarPlaceholder}
                  alt={u.fullName}
                />
              </div>
              <div className={chatSidebarStyles.sidebar__therapist}>
                <p className={chatSidebarStyles.sidebar__name} data-testid="therapist-name">{u.fullName}</p>
                {/*<p className={chatSidebarStyles.sidebar__tag}>*/}
                {/*  appointment: {u?.appointment?.appointments?.id}*/}
                {/*</p>*/}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p className={`text`}>{t('NOT_YET_SCHEDULED_MEETINGS')}</p>
      )}
    </section>
  );
};

export default ChatSideBar;
